const withdrawMap = (type) => {
  if (type === "VIWD") {
    return "DEB";
  }
  return type;
};

export default withdrawMap;
